export const queryKey = {
  documents: (params: object) => ['documents', params],
  packages: (params: object) => ['packages', params],
  package: (packageId: string) => ['package', { packageId }],
  rendered: (documentId: number) => ['document-rendered', { documentId }],
  document: (documentId: number) => ['document', { documentId }],
  documentsQueue: (documentId: number) => ['documentsQueue', { documentId }],
  documentsVersions: (documentId: number) => [
    'documentsVersions',
    { documentId },
  ],
  documentComments: (documentId: number) => [
    'documentComments',
    { documentId },
  ],
  documentsExternalFiles: (documentId: number) => [
    'documentsExternalFiles',
    { documentId },
  ],
  documentAttachments: (documentId: number) => [
    'documentsAttachments',
    { documentId },
  ],
};
